import { Navigate, Outlet } from "react-router-dom";
import React from "react";

const Guest = () => {
  const token = sessionStorage.getItem("ut");
  return token ? <Navigate to="/cashier" /> : <Outlet />;
};

export default Guest;
